<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">TOP > シミュレーション > お届け先入力</div>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <!-- フォームセクション -->
    <div class="container mt-5 form__main">
      <div class="form-card card">
        <div class="card-body">
          <p class="lead form-text-center">販売店向けオーダーシート</p>
          <!-- シミュレーションID -->
          <div class="form-group form-text-center">
            <label for="form-simulation-id" class="form-text-simulationID"
              >シミュレーションID:</label
            >
            <div id="form-simulation-id" class="font-weight-bold">
              {{ sessionID }}
            </div>
          </div>
          <p class="form-text-center">お客様情報の入力(お届け先)</p>
          
          <!-- ▼▼▼ その他の店舗名入力欄 ▼▼▼ -->
          <div class="form-group" v-if="formData.shop === 'other'">
            <label for="other-shop" class="form-label">販売店名を入力 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control"
              id="other-shop"
              ref="otherShop"
              v-model="formData.otherShop"
              placeholder="販売店名を入力してください"
              spellcheck="false"
            />
            <small v-if="formErrors.otherShop" class="text-danger">
              {{ formErrors.otherShop }}
            </small>
          </div>

          <!-- ▼▼▼ お名前 ▼▼▼ -->
          <div class="form-group">
            <label for="form-name" class="form-label">お名前 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control"
              id="form-name"
              ref="name"
              v-model="formData.name"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.name" class="text-danger">
              {{ formErrors.name }}
            </small>
          </div>

          <!-- ▼▼▼ お名前（カナ） ▼▼▼ -->
          <div class="form-group">
            <label for="form-name-kana" class="form-label">お名前（カナ） <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control"
              id="form-name-kana"
              ref="nameKana"
              v-model="formData.nameKana"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.nameKana" class="text-danger">
              {{ formErrors.nameKana }}
            </small>
          </div>

          <!-- ▼▼▼ 郵便番号 ▼▼▼ -->
          <div class="form-group">
            <label for="postcode" class="form-label">郵便番号 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control form-min"
              id="postcode"
              ref="postcode"
              v-model="formData.postcode"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.postcode" class="text-danger">
              {{ formErrors.postcode }}
            </small>
          </div>

          <!-- ▼▼▼ 都道府県 ▼▼▼ -->
          <div class="form-group">
            <label for="form-prefecture" class="form-label">都道府県 <span class="required-icon">必須</span></label>
            <div class="dropdown-wrapper">
              <select
                class="form-control form-min-city city-triangle"
                id="form-prefecture"
                ref="prefecture"
                v-model="formData.prefecture"
                :class="{ open: isOpen }"
                @focus="isOpen = true"
                @change="isOpen = false"
                @blur="isOpen = false"
                required
                spellcheck="false"
              >
                <option value=""></option>
                <option v-for="pref in prefectures" :key="pref" :value="pref">
                  {{ pref }}
                </option>
              </select>
              <span class="arrow" :class="{ open: isOpen }"></span>

            </div>
            <small v-if="formErrors.prefecture" class="text-danger">
              {{ formErrors.prefecture }}
            </small>
          </div>

          <!-- ▼▼▼ 市区町村 ▼▼▼ -->
          <div class="form-group">
            <label for="form-city" class="form-label">市区町村 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control"
              id="form-city"
              ref="city"
              v-model="formData.city"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.city" class="text-danger">
              {{ formErrors.city }}
            </small>
          </div>

          <!-- ▼▼▼ 町名・番地 ▼▼▼ -->
          <div class="form-group">
            <label for="form-street" class="form-label">町名・番地 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control"
              id="form-street"
              ref="street"
              v-model="formData.street"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.street" class="text-danger">
              {{ formErrors.street }}
            </small>
          </div>

          <!-- ▼▼▼ ビル・マンション名 ▼▼▼ -->
          <div class="form-group">
            <label for="form-building" class="form-label">
              ビル・マンション名・部屋番号
            </label>
            <input
              type="text"
              class="form-control"
              id="form-building"
              ref="building"
              v-model="formData.building"
              placeholder=""
              spellcheck="false"
            />
            <small v-if="formErrors.building" class="text-danger">
              {{ formErrors.building }}
            </small>
          </div>

          <!-- ▼▼▼ 電話番号 ▼▼▼ -->
          <div class="form-group">
            <label for="form-phone" class="form-label">電話番号 <span class="required-icon">必須</span></label>
            <input
              type="text"
              class="form-control form-min"
              id="form-phone"
              ref="phone"
              v-model="formData.phone"
              placeholder=""
              required
            />
            <small v-if="formErrors.phone" class="text-danger">
              {{ formErrors.phone }}
            </small>
          </div>

          <!-- ▼▼▼ メールアドレス ▼▼▼ -->
          <div class="form-group">
            <label for="form-email" class="form-label">メールアドレス <span class="required-icon">必須</span></label>
            <input
              type="email"
              class="form-control"
              id="form-email"
              ref="email"
              v-model="formData.email"
              placeholder=""
              required
              spellcheck="false"
            />
            <small v-if="formErrors.email" class="text-danger">
              {{ formErrors.email }}
            </small>
          </div>

          <!-- ▼▼▼ オリジナル刺繍 (チェックボックス1つ) ▼▼▼ -->
          <div class="form-group-original">
            <label for="form-original" class="form-label">オリジナル刺繍</label>
            <div class="checkbox-option">
              <input
                class="form-check-input custom-checkbox"
                type="checkbox"
                id="checkboxOriginal"
                ref="original"
                v-model="formData.originalChecked"
              />
              <label class="form-check-label" for="checkboxOriginal"
                >希望する</label
              >
            </div>
          </div>


          <div class="form-row form__btn_gap">
            <div class="col">
              <button
                class="form-btn-block form-btn-secondary btn btn-block"
                @click="goBackToOrder"
              >
                シミュレーションに戻る
              </button>
            </div>
            <div class="col">
              <!-- ボタン -->
              <button
                type="submit"
                class="form-btn-block form-btn-primary btn btn-block"
                @click="goToConfirmation"
              >
                ご注文内容の確認に進む
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  name: "ShoporderForm",
  data() {
    return {
      simulationId: "123456789", // シミュレーションID（仮）
      isOpen: false, // ドロップダウンの開閉状態
      isOpenShop: false, // ドロップダウンの開閉状態
      formData: {
        shop: "other",
        otherShop: "", // "その他"を選んだ場合の手入力用
        name: "",
        nameKana: "",
        postcode: "",
        prefecture: "",
        city: "",
        street: "",
        building: "",
        phone: "",
        email: "",
        originalChecked: false,
      },

      formErrors: {
        shop: '',
        otherShop: '',
        name: '',
        nameKana: '',
        postcode: '',
        prefecture: '',
        city: '',
        street: '',
        building: '',
        phone: '',
        email: '',
      },

      prefectures: [
        "北海道",
        "青森県",
        "岩手県",
        "宮城県",
        "秋田県",
        "山形県",
        "福島県",
        "茨城県",
        "栃木県",
        "群馬県",
        "埼玉県",
        "千葉県",
        "東京都",
        "神奈川県",
        "新潟県",
        "富山県",
        "石川県",
        "福井県",
        "山梨県",
        "長野県",
        "岐阜県",
        "静岡県",
        "愛知県",
        "三重県",
        "滋賀県",
        "京都府",
        "大阪府",
        "兵庫県",
        "奈良県",
        "和歌山県",
        "鳥取県",
        "島根県",
        "岡山県",
        "広島県",
        "山口県",
        "徳島県",
        "香川県",
        "愛媛県",
        "高知県",
        "福岡県",
        "佐賀県",
        "長崎県",
        "熊本県",
        "大分県",
        "宮崎県",
        "鹿児島県",
        "沖縄県",
      ],
      selected: {}, // ローカルストレージから取得する選択データ
      totalPrice: 0,
      savedSelections: [],
      isAlertShown: false,
      sessionID: "",
    };
  },

  mounted() {
    const postcodeInput = document.getElementById("postcode");

    if (postcodeInput) {
      postcodeInput.addEventListener("input", this.handlePostcodeInput);
      postcodeInput.addEventListener("change", this.handlePostcodeInput);
      postcodeInput.addEventListener("keyup", this.handlePostcodeInput);
    }
    // localStorage から totalPrice を取得
    const storedPrice = localStorage.getItem("totalPrice");
    if (storedPrice) {
      this.totalPrice = parseInt(storedPrice, 10);
    }

    // selectedData も同様に
    const selectedData = localStorage.getItem("selectedData");
    if (selectedData) {
      this.selectedData = JSON.parse(selectedData);
    }
  },

  created() {
    // ローカルストレージから選択データを取得
    const savedData = localStorage.getItem("selectedData");
    if (savedData) {
      this.selected = JSON.parse(savedData);
    }

    // ★ここから追加：ローカルストレージから savedSelections を取得
    const savedSelectionsString = localStorage.getItem("savedSelections");
    if (savedSelectionsString) {
      this.savedSelections = JSON.parse(savedSelectionsString);
    } else {
      this.savedSelections = [];
    }
    console.log(
      "OrderPageでショップオーダーフォームのsavedSelections:",
      this.savedSelections
    );

    // 確認ページから「戻る」で遷移してきた場合、入力内容をsessionStorageから復元する
    Object.keys(this.formData).forEach((key) => {
      const savedValue = sessionStorage.getItem(key);
      if (savedValue !== null) {
        this.formData[key] =
          key === "originalChecked" ? savedValue === "true" : savedValue;
      }
    });

    this.generateNewSessionID();
  },

  methods: {
    handlePostcodeInput() {
      let postcode = this.formData.postcode.trim().replace(/-/g, "");

      // 7桁の数字でなければ処理しない
      if (!/^\d{7}$/.test(postcode)) {
        return;
      }

      fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postcode}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.results) {
            const address = data.results[0];
            this.formData.prefecture = address.address1;
            this.formData.city = address.address2;
            this.formData.street = address.address3;
          } else {
            // すでにアラートが出ていたら何もしない
            if (this.isAlertShown) return;

            this.isAlertShown = true; // アラートフラグをON
            alert("該当する住所が見つかりません。郵便番号を確認してください。");

            // **フォームデータの郵便番号をリセット**
            this.formData.postcode = "";

            // 1秒後にアラートフラグをリセット（再度アラートが出せるようにする）
            setTimeout(() => {
              this.isAlertShown = false;
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("API呼び出しエラー:", error);
          alert("住所の取得に失敗しました。");
        });
    },

    generateNewSessionID() {
      // 新しいセッションIDを発行
      this.sessionID = uuidv4().replace(/-/g, "").substring(0, 12)

      // 最新の選択データを取得
      const latestData = {
        selected: JSON.parse(localStorage.getItem("selectedData")) || {},
        selection: JSON.parse(localStorage.getItem("selection")) || {},
        savedSelections:
          JSON.parse(localStorage.getItem("savedSelections")) || [],
      };

      // 新しいセッションIDをローカルストレージに保存（上書き）
      localStorage.setItem("sessionID", this.sessionID);
      sessionStorage.setItem("sessionID", this.sessionID); // ←追加
      // 最新データを新しいセッションIDに紐づけて保存
      localStorage.setItem(this.sessionID, JSON.stringify(latestData));
    },

    handleSubmit() {
      console.log(this.formData);

      // 確認のアラート
      alert("ご注文内容を確認しました。");

      // sessionStorageにデータを保存
      Object.keys(this.formData).forEach((key) => {
        sessionStorage.setItem(key, this.formData[key]);
      });

      // 新しいタブで確認ページを開く
      const confirmationPageUrl = "/confirmationPage";
      window.open(confirmationPageUrl, "_blank");
    },

    toggleOtherShop() {
      this.showOtherShop = this.formData.shop === "other";
    },

    // ▼▼▼▼▼ バリデーションメソッド ▼▼▼▼▼
    validateShop() {
      // ショップ選択チェック
      if (!this.formData.shop) {
        this.formErrors.shop = '販売店を選択してください。';
      } else {
        this.formErrors.shop = '';
      }
      // その他の場合の文字チェック: 漢字,ひらがな,カタカナ,アルファベットのみ,20文字以内
      if (this.formData.shop === 'other') {
        if (!this.formData.otherShop.trim()) {
          this.formErrors.otherShop = '販売店名を入力してください。';
        } else if (!/^[\p{Script=Han}a-zA-Zぁ-んァ-ヶ々〆〤]{1,20}$/u.test(this.formData.otherShop)) {
          this.formErrors.otherShop = '販売店名は漢字・ひらがな・カタカナ・半角アルファベットのみ20文字以内で入力してください。';
        } else {
          this.formErrors.otherShop = '';
        }
      } else {
        // other 以外ならリセット
        this.formErrors.otherShop = '';
      }
    },

    // バリデーションメソッド
    validateName(name) {
      // 漢字、ひらがな、カタカナ、アルファベットのみ許可
      const nameRegex = /^[\p{Script=Han}a-zA-Zぁ-んァ-ヶ々〆〤]+$/u;
      return nameRegex.test(name);
    },

    validateKana(kana) {
      // カタカナのみ許可
      const kanaRegex = /^[ァ-ヶー]+$/;
      return kanaRegex.test(kana);
    },

    validatePostcode(postcode) {
      // ハイフン削除
      const cleanedPostcode = postcode.replace(/-/g, "");
      const postcodeRegex = /^\d{7}$/;
      return postcodeRegex.test(cleanedPostcode) ? cleanedPostcode : null;
    },

    validateStreet(street) {
      return street.length <= 48;
    },

    validateBuilding(building) {
      // 未入力ならスキップ
      if (!building) return true;
      return building.length <= 48;
    },

    validatePhone(phone) {
      const cleanedPhone = phone.replace(/-/g, "");
      const phoneRegex = /^0\d{9,10}$/;
      return phoneRegex.test(cleanedPhone) ? cleanedPhone : null;
    },

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    goToConfirmation() {
      const requiredFields = [
      { key: 'shop', label: '販売店名' },
      { key: 'name', label: 'お名前' },
      { key: 'nameKana', label: 'お名前（カナ）' },
      { key: 'postcode', label: '郵便番号' },
      { key: 'prefecture', label: '都道府県' },
      { key: 'city', label: '市区町村' },
      { key: 'street', label: '町名・番地' },
      { key: 'phone', label: '電話番号' },
      { key: 'email', label: 'メールアドレス' },
      ];

      // バリデーションの初期化
      this.formErrors = {};
      requiredFields.forEach(field => {
        this.formErrors[field.key] = ''; // 初期化
      });

      // 必須項目が未入力の場合のエラーメッセージ
      requiredFields.forEach(field => {
        if (!this.formData[field.key]?.trim()) {
          this.formErrors[field.key] = `${field.label}を入力してください。`;
        }
      });

      // (1) ショップバリデーション
      this.validateShop();

        // 各項目のバリデーション（入力があっても不正な場合）
      if (this.formData.name) {
        if (!this.validateName(this.formData.name)) {
          this.formErrors.name = "お名前は漢字、ひらがな、カタカナ、半角アルファベットのみ入力可能です。";
        }
      }

      if (this.formData.nameKana) {
        if (!this.validateKana(this.formData.nameKana)) {
          this.formErrors.nameKana = "お名前（カナ）はカタカナのみ入力してください。";
        }
      }

      if (this.formData.postcode) {
        const validPostcode = this.validatePostcode(this.formData.postcode);
        if (validPostcode) {
          this.formData.postcode = validPostcode;
        } else {
          this.formErrors.postcode = this.formErrors.postcode
            ? "郵便番号は正しい形式で入力してください（例: 123-4567 または 1234567）。"
            : this.formErrors.postcode; // すでに未入力エラーがある場合は上書きしない
        }
      }

      if (this.formData.street) {
        if (!this.validateStreet(this.formData.street)) {
          this.formErrors.street = "町名・番地は48文字以内で入力してください。";
        }
      }

      if (this.formData.building) {
        if (!this.validateBuilding(this.formData.building)) {
          this.formErrors.building = "ビル・マンション名は48文字以内で入力してください。";
        }
      }

      if (this.formData.phone) {
        const validPhone = this.validatePhone(this.formData.phone);
        if (validPhone) {
          this.formData.phone = validPhone;
        } else {
          this.formErrors.phone = this.formErrors.phone
            ? "電話番号は正しい形式で入力してください（例: 09012345678）。"
            : this.formErrors.phone;
        }
      }

      if (!this.formData.email.trim()) {
        this.formErrors.email = "メールアドレスを入力してください。";
      } else if (!this.validateEmail(this.formData.email)) {
        this.formErrors.email = "メールアドレスは正しい形式で入力してください（例: example@example.com）。";
      } else {
        this.formErrors.email = ""; // エラーなしの場合はリセット
      }

      // ▼ オリジナル刺繍の値を更新 (チェックなら希望する, なければ希望しない)
      this.formData.original = this.formData.originalChecked ? '希望する' : '希望しない';

      // バリデーションエラーがある場合は処理を中断
      const hasErrors = Object.values(this.formErrors).some(err => err !== '');
      if (hasErrors) {
        // エラーがある場合、最初のエラー箇所にスクロール
        const firstErrorKey = Object.keys(this.formErrors).find(
          (key) => this.formErrors[key] !== ''
        );
        this.$nextTick(() => {
          if (firstErrorKey && this.$refs[firstErrorKey]) {
            this.$refs[firstErrorKey].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            this.$refs[firstErrorKey].focus();
          }
        });
        return; // エラーがある場合、処理を中断
      }

      // sessionStorageにデータを保存
      Object.keys(this.formData).forEach((key) => {
        sessionStorage.setItem(key, this.formData[key]);
      });

      // sessionStorageに選択データ(selectedData)を保存
      // const selectedData = JSON.parse(localStorage.getItem("selectedData")); // ローカルストレージから取得
      // if (selectedData) {
      //   sessionStorage.setItem("selectedData", JSON.stringify(selectedData));
      // }
      sessionStorage.setItem("shop", this.formData.shop);
      sessionStorage.setItem("otherShop", this.formData.otherShop);
      // selectedData も sessionStorage に保存
      sessionStorage.setItem("selectedData", JSON.stringify(this.selectedData));

      // ★ ここで totalPrice も sessionStorage に保存
      //   (さらに ConfirmationPage で使うため)
      sessionStorage.setItem("totalPrice", this.totalPrice.toString());

      // ★ここを追加：刺繍設定も sessionStorage に保存！
      sessionStorage.setItem(
        "savedSelections",
        JSON.stringify(this.savedSelections)
      );
      sessionStorage.setItem("sessionID", localStorage.getItem("sessionID"));

      // 同じ画面で確認ページに遷移する
      this.$router.push({ name: "ConfirmationPage" });
    },

    goBackToOrder() {
      // sessionStorage に復元用フラグをセット
      sessionStorage.setItem("restoreData", "true");
      // Order ページに遷移（Vue Router を利用）
      this.isRestoring = true;
      this.$router.push("/order");
    },
  },

  
  beforeRouteLeave(to, from, next) {
    // ページを離れる前に、sessionStorage に「restoreData」フラグをセットする
    sessionStorage.setItem("restoreData", "true");
    next();
  },
};
</script>

<style scoped>
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 3vw 0;
}
.col {
  padding-right: 5px;
  padding-left: 5px;
}

.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form__main {
  max-width: 700px;
}

.form-control::placeholder {
  color: #fff;
  opacity: 1;
}

@media (max-width: 480px) {
  .form-btn-block {
    font-size: 10px;
  }
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  -webkit-text-fill-color: #fff !important; /* テキスト色を白 */
  box-shadow: 0 0 0px 1000px #000 inset !important; /* 背景を完全に黒で塗りつぶす */
}

/* Firefox用 */
input:-moz-autofill,
textarea:-moz-autofill,
select:-moz-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  color: #fff !important; /* テキスト色を白 */
}

/* :active時の色変更を防ぐ */
.form-btn-block:active {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

/* :focus-visible時の色変更を防ぐ */
.form-btn-block:focus-visible {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

.text-danger {
  margin-top: 0.25rem; /* 必要に応じて調整 */
  display: block; /* ブロック要素にすることで、横幅いっぱいに表示 */
}

.form-control {
  margin-bottom: 0px;
  padding: 7px 10px;
}
.navbar {
  padding: 8px 10px;
}

.form__btn_gap {
  gap: 1vw;
  padding: 48px 0 0 0;
}

.form-group-original label {
  margin: 0; /* 不要な余白を削除 */
  line-height: 1; /* ラジオボタンとの高さを合わせる */
}

.form-check-label {
  margin-right: 4px;
  cursor: pointer;
}

.form-group-original label {
  padding-top: 5px;

}

/* チェックボックスの枠 */
.form-check-input {
  width: 20px;
  height: 20px;
  border: 2px solid #000;  /* チェックボックスの枠線を黒に */
  background-color: #fff;  /* 背景を白に */
  appearance: none; /* デフォルトのチェックボックスを無効化 */
  border-radius: 4px; /* 角を少し丸く */
  cursor: pointer;
  display: inline-block;
  position: relative;
  margin-right: 10px;
}

/* チェックマークのデザイン */
.form-check-input:checked {
  background-color: #fff;  /* チェックボックスの背景は白 */
  border-color: #000; /* 枠線は黒 */
}

/* チェックマークの追加（疑似要素で作る） */
.form-check-input:checked::before {
  content: "✔";  /* チェックマーク */
  color: #000;  /* チェックマークを黒に */
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox-option {
  display: flex;
  text-align: center;
  align-items: center;
  padding-top: 4px;
}
.arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  /* 初期は閉じてる状態で下向きの三角 */
  border-top: 8px solid #fff;

}

.arrow.open {
  /* 開いてるときは上向きの三角 */
  border-top: none;
  border-bottom: 8px solid #fff;
}

.arrow-shop {
  position: absolute;
  right: 12px;
  top: 71%;
  transform: translateY(-50%);
  pointer-events: none;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  /* 初期は閉じてる状態で下向きの三角 */
  border-top: 8px solid #fff;
}

.arrow-shop.open {
  /* 開いてるときは上向きの三角 */
  border-top: none;
  border-bottom: 8px solid #fff;
}
.required-icon {
  background-color: #ED4F64;
  font-size: 0.7rem;
  padding: 2px 9px 3px 7px;
  border-radius: 4px;
  margin-left: 10px;
  margin-bottom: 1px
}

.form-label {
  display: flex;
  align-items: center;
  text-align: center;
}

.form-text-simulationID{
  margin-right: 5px;
  font-size: 12px;
}
</style>
